// extracted by mini-css-extract-plugin
module.exports = {"styleRow":"OperationsMenuMobile_styleRow__1x2tj","mb":"OperationsMenuMobile_mb__2LCzE","link":"OperationsMenuMobile_link__70EnH"};